import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { rememberLoginRedirect } from './login-redirect';
let AuthGuard = class AuthGuard {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate(route, state) {
        if (!this.authService.isAuthenticated()) {
            // a mailed wallet-passphrase link gets the login window and comes back to the link (#2740)
            if (state && rememberLoginRedirect(state.url)) {
                this.router.navigateByUrl('/login');
                return false;
            }
            this.router.navigateByUrl('');
            return false;
        }
        return true;
    }
};
AuthGuard.ctorParameters = () => [
    { type: AuthService },
    { type: Router }
];
AuthGuard = __decorate([
    Injectable()
], AuthGuard);
export { AuthGuard };
